import { render, staticRenderFns } from "./ElementOverviewElementModal.vue?vue&type=template&id=4b5ba931&scoped=true&"
import script from "./ElementOverviewElementModal.vue?vue&type=script&lang=js&"
export * from "./ElementOverviewElementModal.vue?vue&type=script&lang=js&"
import style0 from "./ElementOverviewElementModal.vue?vue&type=style&index=0&id=4b5ba931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ba931",
  null
  
)

export default component.exports